import { render, staticRenderFns } from "./ArchiveCastersList.vue?vue&type=template&id=197c4364&scoped=true&"
import script from "./ArchiveCastersList.vue?vue&type=script&lang=js&"
export * from "./ArchiveCastersList.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveCastersList.vue?vue&type=style&index=0&id=197c4364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c4364",
  null
  
)

export default component.exports